import httpClient from "@plugins/http";
import { ApiResponse } from "@apis/api.ts";

const fetchSchoolDetail = () => {
  return httpClient.get(`/apis/school/myschool`);
};

// TODO: [API] rename api url to all apis/school/
const fetchSchoolFormClass = (currentSchoolCode) => {
  return httpClient.get(`/apis/school/form-classes/${currentSchoolCode}`);
};

const fetchSchools = (requestData) => {
  return httpClient.get(`/apis/schools`, { params: requestData });
};

const fetchAllSchools = () => {
  return httpClient.get(`/apis/school/getAllSchool`);
};

const getAdministratedSchools = () => {
  return httpClient.get("/apis/schools/administrated");
};

const getTeacherAndAdministratedSchools = () => {
  return httpClient.get("/apis/schools/admin/all");
};

const getAdministrableSchools = () => {
  return httpClient.get(`/apis/schools/administrable`);
};

const fetchSchoolAdminFormClasses = (schoolId) => {
  return httpClient.get(`/apis/school/admin/form-classes/${schoolId}`);
};

const fetchAllSchoolList = () => {
  return httpClient.get(`/apis/schools`);
};

const uploadCSV = (requestData): Promise<ApiResponse<void>> => {
  return httpClient.post(`/apis/schools/import`, requestData);
};

const fetchAllNonAdministrableSchools = () => {
  return httpClient.get(`/apis/schools/non-administrable`);
};

export default {
  fetchSchoolFormClass,
  fetchSchoolDetail,
  fetchSchools,
  getAdministratedSchools,
  getAdministrableSchools,
  fetchAllNonAdministrableSchools,
  getTeacherAndAdministratedSchools,
  fetchSchoolAdminFormClasses,
  fetchAllSchoolList,
  uploadCSV,
  fetchAllSchools,
};
